module.exports = __webpack_public_path__ + "img/word.6b124e3d.svg";